import { Component, OnInit, Inject } from '@angular/core';
import { UserService } from 'app/modules/shared/services/user.service';
import { ClientContactsService } from 'app/modules/settings/services/client-contacts.service';
import { ContactModel } from 'app/modules/settings/interfaces/company-account-data';
import { CurrentUserStateService } from 'app/modules/shared/services/current-user-state.service';
import { ImpersonationService } from 'app/modules/shared/services/impersonation.service';
import { VersionService } from '../../../services/version.service';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ClientsService } from 'app/modules/shared/services/clients.service';

@Component({
    selector: 'app-help-dialog',
    templateUrl: './help-dialog.component.html',
    styleUrls: ['./help-dialog.component.scss'],
})
export class HelpDialogComponent implements OnInit {
    contacts: ContactModel[];
    primaryContactEmail: string;
    supportLink: string;
    isPowerUser: boolean;
    public version;
    knowledgeBase: KnowledgeBaseData;
    losData: any;
    isSuperUser: boolean;
    isBaseClient: boolean;

    constructor(
        public dialogRef: MatDialogRef<HelpDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private userService: UserService,
        private clientContactsService: ClientContactsService,
        private currentUserStateService: CurrentUserStateService,
        private impersonationService: ImpersonationService,
        private versionService: VersionService,
        private clientService: ClientsService
    ) {}

    ngOnInit() {
        this.isPowerUser = this.currentUserStateService.isPowerUser();
        this.isSuperUser = this.currentUserStateService.isLBASuperUser();
        this.isBaseClient = this.currentUserStateService.isBaseClient();

        let clientShortName = this.currentUserStateService.currentUser.clientShortName;

        if (this.impersonationService.isImpersonatingClient()) {
            this.isBaseClient = false;

            clientShortName = this.impersonationService.impersonateClient;

            if (this.impersonationService.isImpersonatingUser()) {
                let clientUser = this.impersonationService.impersonateUser;

                this.userService.getUserByEmail(clientUser).subscribe((data) => {
                    this.isPowerUser = data.isClientAdmin;
                    this.isSuperUser = data.isSuperUser;
                });
            }

            this.clientService.getClientData(clientShortName).subscribe((data) => {
                if (data) {
                    this.isBaseClient = data.nvLite;
                }
            });
        }

        if (!this.isBaseClient) {
            this.clientContactsService.getContactsByName(clientShortName).subscribe(
                (data) => {
                    if (data && data.length > 0) {
                        this.contacts = data;

                        let primaryContact = this.contacts.find(
                            (contact) => contact.contactTypeAbbr == 'Primary'
                        );

                        if (primaryContact && primaryContact.contactValue) {
                            this.primaryContactEmail = primaryContact.contactValue;
                            this.supportLink = 'mailto:' + this.primaryContactEmail;
                        }
                    }
                },
                (error) => {
                    throw new Error(error);
                }
            );
        }

        this.getAppVersion();
        this.getKnowledgeBaseUrl();
        this.getClientLoanMetrics();
    }

    getAppVersion() {
        this.versionService.getAppVersion().subscribe((res) => {
            this.version = res;
        });
    }

    getKnowledgeBaseUrl() {
        this.versionService.getKnowledgeBaseUrl().subscribe((res) => {
            if (res && res.baseUrl) {
                this.knowledgeBase = res;
            } else {
                this.knowledgeBase = null;
            }
        });
    }

    clickKnowledgeBaseUrl() {
        if (this.knowledgeBase && this.knowledgeBase.formatted) {
            window.open(this.knowledgeBase.formatted, '_blank');
        }
    }
    onNoClick(): void {
        this.dialogRef.close();
    }

    getClientLoanMetrics() {
        this.losData = null;

        try {
            this.versionService.getClientLoanMetrics().subscribe((res) => {
                if (res) {
                    this.losData = res;
                }
            });
        } catch (e) {
            this.losData = null;
            throw new Error(e);
        }
    }
}

export interface KnowledgeBaseData {
    baseUrl: string;
    formatted: string;
}
